import { render, staticRenderFns } from "./bind-account.vue?vue&type=template&id=3e1b5d9f&scoped=true&"
import script from "./bind-account.vue?vue&type=script&lang=js&"
export * from "./bind-account.vue?vue&type=script&lang=js&"
import style0 from "./bind-account.vue?vue&type=style&index=0&id=3e1b5d9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1b5d9f",
  null
  
)

export default component.exports